import Modal from "components/layout/modal";
import { FunctionComponent } from "react";
import { useLocale, useLocales } from "stores/hooks/locale";
import Form from "../form";
import Row from "components/grid/row";
import Grid from "components/grid/grid";
import Col from "components/grid/col";
import FormButtons, { FormButtonInterface } from "../buttons";
import { CancelButton, SubmitButton } from "../buttons.utils";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TextInput from "../inputs/text";
import { useTranslate } from "stores/hooks/translation";
import TextareaInput from "../inputs/textarea";
import { LocaleString } from "models/locale";
import { repair } from "lib/locale";
import { faSave } from "components/icon-library";

interface TranslationModalProps {
  onClose: () => Promise<void>;
  onSubmit: (value: LocaleString) => Promise<void>;
  label: string;
  type: "text" | "textarea";
  value: LocaleString;
}

const TranslationModal: FunctionComponent<TranslationModalProps> = ({
  onClose,
  onSubmit,
  label,
  type,
  value,
}) => {
  const locale = useLocale();
  const locales = useLocales();
  const translate = useTranslate();

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, text: "Tallenna", postIcon: faSave },
  ];

  const defaults = { ...value };
  repair(defaults, locale, locales);

  const obj: any = {};
  const defaultValues: any = { ...defaults };

  locales.forEach((l) => {
    obj[l] = yup.string().validateRequired();
  });

  const schema = yup.object(obj).required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const handleSubmit = async (values: any) => {
    onSubmit(values);
  };

  return (
    <Modal title={label}>
      <Form methods={methods} onSubmit={handleSubmit}>
        <Grid>
          {locales.map((loc) => {
            return (
              <Row key={loc}>
                <Col>
                  {type === "text" && (
                    <TextInput
                      name={loc}
                      label={translate(`show_in_locale_${loc}`)}
                    />
                  )}
                  {type === "textarea" && (
                    <TextareaInput
                      name={loc}
                      label={translate(`show_in_locale_${loc}`)}
                    />
                  )}
                </Col>
              </Row>
            );
          })}
        </Grid>
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default TranslationModal;
